import type { MensagemStatus } from '../types';

const STATUS_RANK: Record<MensagemStatus, number> = {
  PENDING: 0,
  SENT: 1,
  DELIVERED: 2,
  SEEN: 3,
  FAILED: 4,
};

/** Aceita avanço monotônico; FAILED sempre aplicável; não regride após FAILED. */
export function canApplyMensagemStatus(current: MensagemStatus, next: MensagemStatus): boolean {
  if (current === next) return true;
  if (next === 'FAILED') return true;
  if (current === 'FAILED') return false;
  return STATUS_RANK[next] >= STATUS_RANK[current];
}
